export default __webpack_public_path__ + "static/char-s-55-zh-Hans-d7dd186630cf4bc3e741b9ff34fce078.png";